import React from 'react'
import { DropOptions } from '../../../../shared/components/forms/drop-options/DropOptions'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { usePostAffiliateUpdateMutation } from '../../../../app/api'
import { useTranslation } from 'react-i18next'

interface StatusCellProps {
  id: number
  status_id: number
  statuses?: any[]
  onRefetch: () => void
}

export const StatusCell = ({ id, status_id, statuses, onRefetch }: StatusCellProps) => {
  const { t } = useTranslation()
  const [updateStatus] = usePostAffiliateUpdateMutation()

  const options = statuses
    ?.map((status) => ({ ...status, text: t('fields.options.' + status.text) }))
    .filter((status) => Number(status.value) !== status_id)

  return (
    <DropOptions
      options={options}
      onChange={(e) => {
        if (Number(e) !== status_id) {
          updateStatus({
            body: { scenario: 'update_status', id, status_id: Number(e) },
          }).then(() => onRefetch())
        }
      }}
    >
      <BpButton
        className={'!bg-transparent hover:!bg-grey-300'}
        contentClassName={'font-normal'}
        size={'sm'}
        theme={'light'}
      >
        {t('pages.PPCCompliance.moveTo')}
      </BpButton>
    </DropOptions>
  )
}
